import { Card, Form } from 'ui';
import { JoinedOrganizationsListContent } from './joined-organizations-list-content';
import {
  JoinedOrganizationsListFilters,
  type JoinedOrganizationsListFiltersFormValues,
} from './joined-organizations-list-filters';

type FormValues = JoinedOrganizationsListFiltersFormValues;

type P = {
  getPathToOrganizationDetail: (id: string) => string;
};

const JoinedOrganizationsList = ({ getPathToOrganizationDetail }: P) => (
  <Card>
    <Form<FormValues> noOptional>
      <JoinedOrganizationsListFilters />
      <Form.Item<FormValues> dependencies={['search']} noStyle>
        {({ getFieldsValue }) => {
          const { search } = getFieldsValue();

          return (
            <JoinedOrganizationsListContent getPathToOrganizationDetail={getPathToOrganizationDetail} search={search} />
          );
        }}
      </Form.Item>
    </Form>
  </Card>
);

export default JoinedOrganizationsList;
